import React from 'react';

function XLogo() {
  return (
    <a href={'https://x.com/luminodelabs'} target={'_blank'}>
        <svg
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        height={20}
        viewBox="0 0 300 250"
        fill="#686868"
        >
        <path d="m236 0h46l-101 115 118 156h-92.6l-72.5-94.8-83 94.8h-46l107-123-113-148h94.9l65.5 86.6zm-16.1 244h25.5l-165-218h-27.4z"/>
        </svg>
    </a>
  );
}

export default XLogo;
